import React, { Suspense, lazy } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { HeroTestimonials } from './components/HeroTestimonials';
import { PainSection } from './components/PainSection';
import { ProductSection } from './components/ProductSection';
import { TomosPrimaria } from './components/TomosPrimaria';
import { TomosSecundaria } from './components/TomosSecundaria';
import { BonusSection } from './components/BonusSection';
import { Countdown } from './components/Countdown';
import { PricingSection } from './components/PricingSection';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
// Defer popup until after main content paints — keeps initial load fast.
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function App() {
  return <div className="bg-white text-gray-900 font-sans relative" data-id="element-0">
      <TopBar data-id="element-1" />
      <Hero data-id="element-2" />
      <StatsBar data-id="element-3" />
      <HeroTestimonials data-id="element-4" />
      <PainSection data-id="element-5" />
      <ProductSection data-id="element-6" />
      <TomosPrimaria data-id="element-7" />
      <TomosSecundaria data-id="element-8" />
      <BonusSection data-id="element-9" />
      <Countdown data-id="element-10" />
      <PricingSection data-id="element-11" />
      <Testimonials data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <Footer data-id="element-15" />

      <Suspense fallback={null} data-id="element-16">
        <SocialProofPopup data-id="element-17" />
      </Suspense>
    </div>;
}